import { useTheme } from 'styled-components'

import type { ImageProps } from '../../../types/ui'
import { Typography } from '../../Typography'

import {
  StyledCardsContainer,
  StyledCardWrapper,
  StyledCheckoutContainer,
  StyledContainer,
  StyledMoneyBackContainer,
  StyledMoneyBackImage,
} from './MoneyBack.Styled'

type Props = {
  cardsImages: ImageProps[]
  cardsTitle: string
} & (
  | {
      moneyBackDescription: string
      moneyBackImage: ImageProps
    }
  | {
      moneyBackDescription?: undefined
      moneyBackImage?: undefined
    }
)

export const MoneyBack = ({
  cardsImages,
  cardsTitle,
  moneyBackDescription,
  moneyBackImage,
}: Props) => {
  const theme = useTheme()

  return (
    <StyledContainer>
      {moneyBackImage && (
        <StyledMoneyBackContainer>
          <StyledMoneyBackImage {...moneyBackImage} />
          <Typography
            $color={theme.colors['N Content/Secondary']}
            $variant="Poppins/T2"
            $textAlign="center"
          >
            {moneyBackDescription}
          </Typography>
        </StyledMoneyBackContainer>
      )}
      <StyledCheckoutContainer>
        <Typography $variant="Poppins/T2 - Semibold" $textAlign="center">
          {cardsTitle}
        </Typography>
        <StyledCardsContainer>
          {cardsImages.map((cardImage, index) => {
            return (
              <StyledCardWrapper key={index}>
                <img alt="Card" {...cardImage} />
              </StyledCardWrapper>
            )
          })}
        </StyledCardsContainer>
      </StyledCheckoutContainer>
    </StyledContainer>
  )
}
